export const CONFLICT = 409;
export const NOT_FOUND = 404;
export const SUCCESS = 200;